/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.0.0
 */
import { Fragment } from 'react';

import { FieldProps } from 'formik';

import { Checkbox } from '@components/common';
import { LabelStyled } from '@components/common/Input/styled/InputStyled';

import { ETopicAttrVisibility } from '../../types/createInquiryTypes';
import {
    ErrorMessage,
    FieldRequiredStyled,
    FormItemContainerStyled,
} from './styled/CreateInquiryFormStyled';

export interface ICreateInquiryFormCheckbox {
    label: string;
    placeholder: string;
    required?: boolean;
    visibility: ETopicAttrVisibility;
}


export const CreateInquiryFormCheckbox = ({
    field,
    form: { touched, errors, setFieldValue },
    ...props
}: FieldProps & ICreateInquiryFormCheckbox) => {

    const changeHandler = (e: boolean) => {
        setFieldValue(field.name, e);
    }
    return (
        <FormItemContainerStyled>
            <LabelStyled htmlFor={field.name} kind="normal">
                {props.label}
                {
                    props.required &&
                    <FieldRequiredStyled>*</FieldRequiredStyled>
                }
            </LabelStyled>
            {
                props.visibility !== ETopicAttrVisibility.READ_ONLY &&
                <Fragment>
                    <Checkbox
                        checked={field.value}
                        onChange={changeHandler}
                    />
                    {
                        touched[field.name] &&
                        errors[field.name] &&
                        <ErrorMessage>
                            {
                                errors[field.name]
                            }
                        </ErrorMessage>
                    }
                </Fragment>
            }
        </FormItemContainerStyled>
    );
};
